import React, { useState, useEffect, useMemo } from "react";
import { MaterialReactTable } from "material-react-table";
import { Modal, Paper, Fade, IconButton, Box, Button } from "@mui/material";
import { Edit as EditIcon, Delete as DeleteIcon } from "@mui/icons-material";
import WiredMasterModal from "./AddWiredModal";
import { URL } from "../config";
import axios from "axios";
import toast from "react-hot-toast";

const WiredMasterList = () => {
  const [dataSource, setDataSource] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [editWired, setEditWired] = useState(null);

  const fetchWired = async () => {
    try {
      const res = await axios.get(`${URL}/wiredmasters`);
      setDataSource(
        res.data.data.map((item) => ({
          ...item,
          wiredImage: item.wiredImage ? `${URL}${item.wiredImage}` : "",
        }))
      );
    } catch (err) {
      toast.error("Failed to fetch wired");
    }
  };

  useEffect(() => {
    fetchWired();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this wired?")) return;
    await axios.delete(`${URL}/wiredmasters/${id}`);
    toast.success("Wired deleted successfully!");
    fetchWired();
  };

  const columns = useMemo(() => [
    {
      accessorKey: "actions",
      header: "Actions",
      size: 100,
      Cell: ({ row }) => (
        <Box sx={{ display: "flex", gap: 1 }}>
          <IconButton size="small" onClick={() => {
            setEditWired(row.original);
            setModalVisible(true);
          }}>
            <EditIcon sx={{ color: "#174253" }} fontSize="small" />
          </IconButton>
          <IconButton size="small" onClick={() => handleDelete(row.original.wiredId)}>
            <DeleteIcon sx={{ color: "#d32f2f" }} fontSize="small" />
          </IconButton>
        </Box>
      ),
    },
    { accessorKey: "wiredId", header: "ID", size: 60 },
    { accessorKey: "wiredName", header: "Wire Name", size: 150 },
    {
      accessorKey: "wiredImage",
      header: "Image",
      size: 80,
      Cell: ({ row }) =>
        row.original.wiredImage ? (
          <img
            src={row.original.wiredImage}
            alt="wired"
            style={{
              width: 60,
              height: 60,
              objectFit: "cover",
              borderRadius: 8,
              border: "1px solid #ccc",
            }}
          />
        ) : (
          <Box sx={{
            width: 60,
            height: 60,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 2,
            bgcolor: "#f0f0f0",
          }}>
            W
          </Box>
        ),
    },
  ], []);

  return (
    <Box sx={{ width: "100%", bgcolor: "#ffffff", mt: 2 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
        <Box sx={{ display: "flex", alignItems: "center", fontWeight: 700, fontSize: 22, color: "#174253", letterSpacing: 0.5, borderLeft: "5px solid #174253", pl: 1.5 }}>
          Wire List
        </Box>

        <Button
          sx={{
            borderRadius: 25,
            background: "linear-gradient(90deg, #0b8793, #174253)",
            color: "white",
            "&:hover": { background: "linear-gradient(90deg, #174253, #0b8793)" },
          }}
          onClick={() => {
            setEditWired(null);
            setModalVisible(true);
          }}
        >
          Add Wire
        </Button>
      </Box>

      <Box sx={{ background: "#fff", borderRadius: "0 0 15px 15px" }}>
              <MaterialReactTable
                columns={columns}
                data={dataSource}
                enableColumnActions={false}
                enableDensityToggle={false}
                enableFullScreenToggle={false}
                enableColumnFilters={false}
                enableHiding={false}
                enableGlobalFilter={false}
                muiTablePaperProps={{ sx: { boxShadow: "none", background: "#fff", borderRadius: "15px" } }}
                muiTableContainerProps={{ sx: { backgroundColor: "#fff", width: "100%", overflowX: "auto", borderRadius: "12px" } }}
                muiTableHeadCellProps={{ sx: { backgroundColor: "#e0e0e0ff", color: "#393e4f", fontWeight: 600, fontSize: "16px", borderBottom: "0.5px solid #e3e5eb", textAlign: "left", height: "63px", paddingTop: "23px" } }}
                muiTableBodyRowProps={{ sx: { backgroundColor: "#fff", "&:hover": { backgroundColor: "#eff6fe" }, "& td": { fontSize: { xs: "12px", sm: "14px" }, p: "8px", borderBottom: "0.5px solid #e3e5eb", height: "54px" } } }}
                initialState={{ pagination: { pageIndex: 0, pageSize: 10 } }}
              />
            </Box>
      <Modal open={modalVisible} onClose={() => setModalVisible(false)}>
        <Fade in={modalVisible}>
          <Paper sx={{ bgcolor: "transparent" }}>
            <WiredMasterModal
              wired={editWired}
              onClose={() => {
                setModalVisible(false);
                fetchWired();
              }}
            />
          </Paper>
        </Fade>
      </Modal>
    </Box>
  );
};

export default WiredMasterList;
